// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.voice-icon {
    color: #A261F5;
    font-size: 22px;
    cursor: pointer;
  }
  
  .recording-mic {
    width: 150px;
    height: 150px;
    background-color: rgba(108, 47, 187, 0.1);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px auto 30px auto;
    position: relative;
    z-index: 1;
  }
  
  .recording-mic::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(108, 47, 187, 0.1);
    border-radius: 100%;
    z-index: -1;
    transform: scale(0);
    animation: wave-animation 1.1s infinite;
  }
  
  .voice-status-text {
    font-size: 20px;
    color: #ce6060;
    font-weight: 400;
  }
  
  @keyframes wave-animation {
    0% {
      transform: scale(1);
    }
  
    25% {
      transform: scale(1.2);
    }
  
    50% {
      transform: scale(1.4);
    }
  
    75% {
      transform: scale(1.2);
    }
  
    100% {
      transform: scale(1);
    }
  }
  
  .recording-mic i {
    font-size: 50px;
    color: #6c2fbb;
  }`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/voice-modal/voice-modal.component.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,eAAe;IACf,cAAc;EAChB","sourcesContent":["\n.voice-icon {\n    color: #A261F5;\n    font-size: 22px;\n    cursor: pointer;\n  }\n  \n  .recording-mic {\n    width: 150px;\n    height: 150px;\n    background-color: rgba(108, 47, 187, 0.1);\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 40px auto 30px auto;\n    position: relative;\n    z-index: 1;\n  }\n  \n  .recording-mic::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: rgba(108, 47, 187, 0.1);\n    border-radius: 100%;\n    z-index: -1;\n    transform: scale(0);\n    animation: wave-animation 1.1s infinite;\n  }\n  \n  .voice-status-text {\n    font-size: 20px;\n    color: #ce6060;\n    font-weight: 400;\n  }\n  \n  @keyframes wave-animation {\n    0% {\n      transform: scale(1);\n    }\n  \n    25% {\n      transform: scale(1.2);\n    }\n  \n    50% {\n      transform: scale(1.4);\n    }\n  \n    75% {\n      transform: scale(1.2);\n    }\n  \n    100% {\n      transform: scale(1);\n    }\n  }\n  \n  .recording-mic i {\n    font-size: 50px;\n    color: #6c2fbb;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
